import { H4 } from 'components/Typography';
import { sizes } from 'style';
import styled from 'styled-components';
import Select from 'products/nomad_insurance/components/Select';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 4px;
`;

export const Header = styled(H4)`
  font-weight: 700;
  font-size: 16px;

  @media ${sizes.desktop} {
    font-size: 20px;
  }
`;

export const CustomCountrySelect = styled(Select)`
  border-radius: 16px;
  flex: 1;

  > label {
    font-size: 26px;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
  align-items: flex-start;

  > * {
    flex: 1;
  }

  @media ${sizes.desktop} {
    gap: 16px;
  }
`;
